import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=0d55b81f&"
import script from "./AgentList.vue?vue&type=script&lang=ts&"
export * from "./AgentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports